import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AdminAuthProvider } from "@/context/AuthContext";
import { MemberProvider } from "@/context/MemberContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import MemberGate from "@/components/MemberGate";

import Login from "@/pages/Login";
import AngelsGrid from "@/pages/AngelsGrid";
import AngelDetail from "@/pages/AngelDetail";
import MySelection from "@/pages/MySelection";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import DeleteAccount from "@/pages/DeleteAccount";
import Admin from "@/pages/Admin";
import AdminArtworkBatch from "@/pages/AdminArtworkBatch";
import AdminContact from "@/pages/AdminContact";
import AdminAudit from "@/pages/AdminAudit";
import AdminEmails from "@/pages/AdminEmails";
import AdminHandoffHealth from "@/pages/AdminHandoffHealth";
import AdminAngelsPopularity from "@/pages/AdminAngelsPopularity";
import AdminAttributes from "@/pages/AdminAttributes";
import AdminSecurity from "@/pages/AdminSecurity";
import AdminMembers from "@/pages/AdminMembers";
import AdminArtworkHealth from "@/pages/AdminArtworkHealth";

function App() {
    return (
        <div className="App">
            <MemberProvider>
                <AdminAuthProvider>
                    <BrowserRouter>
                        <Routes>
                            {/* Entry — / accepts Hub handoff via ?token= and routes straight to the picker */}
                            <Route path="/" element={<Navigate to="/angels" replace />} />
                            <Route path="/home" element={<Navigate to="/angels" replace />} />

                            {/* Member-only pages */}
                            <Route path="/angels" element={<MemberGate><AngelsGrid /></MemberGate>} />
                            <Route path="/angels/:number" element={<MemberGate><AngelDetail /></MemberGate>} />
                            <Route path="/selection" element={<MemberGate><MySelection /></MemberGate>} />
                            <Route path="/contact" element={<MemberGate><Contact /></MemberGate>} />

                            {/* Public */}
                            <Route path="/privacy" element={<Privacy />} />
                            <Route path="/terms" element={<Terms />} />
                            <Route path="/delete-account" element={<DeleteAccount />} />

                            {/* Admin */}
                            <Route path="/login" element={<Login />} />
                            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
                            <Route path="/admin/batch" element={<ProtectedRoute><AdminArtworkBatch /></ProtectedRoute>} />
                            <Route path="/admin/contact" element={<ProtectedRoute><AdminContact /></ProtectedRoute>} />
                            <Route path="/admin/audit" element={<ProtectedRoute><AdminAudit /></ProtectedRoute>} />
                            <Route path="/admin/emails" element={<ProtectedRoute><AdminEmails /></ProtectedRoute>} />
                            <Route path="/admin/handoff" element={<ProtectedRoute><AdminHandoffHealth /></ProtectedRoute>} />
                            <Route path="/admin/popularity" element={<ProtectedRoute><AdminAngelsPopularity /></ProtectedRoute>} />
                            <Route path="/admin/attributes" element={<ProtectedRoute><AdminAttributes /></ProtectedRoute>} />
                            <Route path="/admin/security" element={<ProtectedRoute><AdminSecurity /></ProtectedRoute>} />
                            <Route path="/admin/members" element={<ProtectedRoute><AdminMembers /></ProtectedRoute>} />
                            <Route path="/admin/health" element={<ProtectedRoute><AdminArtworkHealth /></ProtectedRoute>} />

                            <Route path="*" element={<Navigate to="/angels" replace />} />
                        </Routes>
                    </BrowserRouter>
                </AdminAuthProvider>
            </MemberProvider>
            <Toaster
                position="top-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#151311",
                        border: "1px solid rgba(207, 160, 82, 0.3)",
                        color: "#e8e4db",
                        fontFamily: "'Outfit', sans-serif",
                        fontSize: "13px",
                    },
                }}
            />
        </div>
    );
}

export default App;
